import clsx from 'clsx';
import React, { useEffect, useRef, useState } from 'react';
import { ActionButton } from '../ActionButton';
import styles from './styles.module.scss';

interface ConfirmModalProps {
  className?: string;
  show: boolean;
  onClose: () => void;
  title: string;
  btitle: string;
  description: string;
  action: () => void;
}
export default function ConfirmModal({
  className,
  show,
  onClose,
  title,
  btitle,
  description,
  action,
}: ConfirmModalProps) {
  const [showStatus, setShowStatus] = useState(show);
  const rootRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
    function handleClick(e: MouseEvent) {
      if (rootRef.current && contentRef.current && e.target instanceof Node) {
        if (rootRef.current.contains(e.target) && !contentRef.current.contains(e.target)) {
          onClose();
        }
      }
    }
  }, [rootRef, contentRef, show]);

  useEffect(() => {
    setShowStatus(show);
  }, [show]);

  return (
    <div className={showStatus ? styles.loaderWrapper : styles.displayNone} ref={rootRef}>
      <div className={styles.modalRoot} ref={contentRef}>
        <div className={styles.title}>{title}</div>
        <div className={styles.mainContainer}>
          <div className={clsx(styles.descContainer, className)}>
            {description.split('\n').map((str, index) => (
              <React.Fragment key={index}>
                {str}
                <br />
              </React.Fragment>
            ))}
          </div>
        </div>
        <div className={styles.btnContainer}>
          <ActionButton
            content='キャンセル'
            action={onClose}
            type='lightFill'
            size='medium'
            icon={null}
          />
          <ActionButton
            content={btitle}
            type='darkFill'
            size='medium'
            action={action}
            icon={null}
          />
        </div>
      </div>
    </div>
  );
}
